/* eslint-disable max-lines */
import styled, { css, keyframes } from 'styled-components';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import ReadMore from '../../ProductListing/molecules/ReadMore/views';

export const CarouselSkeletonContainer = styled.div`
  width: 1000px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: #e1e1e1;
  margin-bottom: 20px;
  padding: 40px 0 20px 15px;
  @media ${(props) => props.theme.mediaQuery.large} {
    width: 100%;
    justify-content: center;
    margin-bottom: 0;
  }
  @media (min-width: 1820px) {
    padding: 40px 0 20px 0;
  }

  .skeleton-view {
    margin-left: 20px;
    height: 179px;
    width: 145px;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 250px;
      width: 200px;
    }
  }
  .skeleton-view:first-child {
    margin-left: 0;
  }
`;

export const CarouselPillLineContainer = styled.div`
  display: flex;
`;

export const CarouselSkeletonPillContainer = styled.div`
  width: 100%;
  padding-top: 30px;
  padding-bottom: 8px;
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    margin-left: 16px;
  }
  .skeleton-pill-view {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 50px;
      min-height: 50px;
      min-width: 120px;
    }
  }
`;
const plpPromoModuleCommon = css`
  .plp-promo-module {
    min-height: 305px;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 350px;
      width: 100%;
      margin-left: 0;
    }
  }
  .carousel-skeleton {
    width: 100%;
    display: block !important;
    min-height: 305px;
    @media ${(props) => props.theme.mediaQuery.large} {
      min-height: 350px;
    }
  }

  [class^='plp-generic-skeleton-'] {
    display: none;
  }

  .pill-variation-plp-promo {
    min-height: 100%;
  }
`;
const plpPromoModuleMobile = css`
  @media ${(props) => props.theme.mediaQuery.mediumOnly},
    ${(props) => props.theme.mediaQuery.smallOnly} {
    ${(props) => (props.isPillVariation ? `` : `margin-top: 15px;`)}
    width: 100vw;
  }
  ${plpPromoModuleCommon}
  .carousel-skeleton {
    overflow: hidden;
    @media ${(props) => props.theme.mediaQuery.large} {
      overflow: none;
    }
  }
`;
const plpPromoModuleDesktop = css`
  ${plpPromoModuleCommon}
  .plp-landing-skeleton.desktop {
    display: none;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: block;
    }
  }
`;

export const PlpGrid = styled.div`
  display: flex;
  flex-direction: row;
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    flex-direction: column;
    margin: 0 15px;
    ${({ alignCenterAndAddSpaceBetween }) =>
      alignCenterAndAddSpaceBetween && `align-items: center; justify-content: space-between;`}
    ${({ showTotalProductCount }) =>
      showTotalProductCount &&
      `flex-direction:row; margin-bottom: 16px; margin-top 14px; column-gap: 16px; align-items: flex-start;`}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${({ alignCenterAndAddSpaceBetween }) =>
      alignCenterAndAddSpaceBetween && `align-items: center; justify-content: space-between;`}
    ${({ showTotalProductCount }) =>
      showTotalProductCount && `flex-direction:row; margin-bottom: 16px; column-gap: 16px;`}
  }
  .sidebar.filter-redesign {
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 260px;
      flex: none;
      display: flex;
      flex-direction: column;
    }
    @media ${(props) => props.theme.mediaQuery.desktop} {
      width: 300px;
    }
  }
  ${plpPromoModuleDesktop}
  .sidebar.filter-redesign.hide-left-navigation {
    @media ${(props) => props.theme.mediaQuery.large} {
      display: none;
    }
  }
`;

export const PlpGridColumn = styled.div`
  min-width: 0;
  ${(props) => (props.grow ? `flex-grow: 1;` : ``)}
  ${(props) => (props.minWidth ? `min-width: ${props.minWidth};` : ``)}
  ${(props) => (props.alignCenter ? `align-items: center;` : ``)}
  ${(props) =>
    props.showInDesktop
      ? `display: none; @media ${props.theme.mediaQuery.large} { display: flex; flex-direction: column; }`
      : `display: flex; flex-direction: column;`}

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: ${(props) => (!props.breadcrumbs && !props.pagination ? '0 30px' : '0')};
  }
`;

export const ProductsCountWrapper = styled.div`
  display: flex;
  column-gap: 6px;
  flex-shrink: 0;

  @media ${(props) => props.theme.mediaQuery.large} {
    margin-right: 28px;
    ${({ showTotalProductCount }) => !showTotalProductCount && 'padding-bottom: 12px;'}
  }

  .current-page-product-range,
  .products-count-divider {
    color: #000;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 14px;
    }
  }

  .products-count-divider {
    font-weight: 400;
  }
`;

export const TotalProductsCountWrapper = styled.div`
  display: flex;
  column-gap: 4px;

  .items-count,
  .items-label {
    color: #000;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 150%;

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 14px;
    }
  }

  .items-label {
    font-weight: 400;
  }
`;

export const PlpBreadCrumb = styled.div`
  ${({ showTotalProductCount }) => !showTotalProductCount && 'padding-bottom: 12px;'}
  display: flex;
  ${({ showTotalProductCount }) => !showTotalProductCount && 'margin-left: 18px;'}
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${({ showTotalProductCount }) => !showTotalProductCount && 'margin: 20px 0px 0px;'}

    ${({ showTotalProductCount }) =>
      showTotalProductCount &&
      css`
        .breadcrum-container,
        .breadcrum-item-container,
        .breadcrum-item.breadcrum-item.breadcrum-item {
          color: #1a1a1a;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 160%;
          text-decoration-skip-ink: none;
        }
        .breadcrum-last-item.breadcrum-last-item {
          font-size: 12px;
          font-weight: 800;
        }
        .breadcrum-separation.breadcrum-separation {
          margin: 0 6px;
          font-size: 10px;
          font-weight: 500;
        }
      `}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${({ showTotalProductCount }) =>
      showTotalProductCount &&
      css`
        margin-left: 16px;
      `}
  }
`;

export const StyledLoaderSkelton = styled.div`
  height: 100vh;
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    height: 64px;
    width: 100%;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    width: 260px;
    padding: 0 19px;
    flex: none;
    display: flex;
    flex-direction: column;
    border-right: 2px solid rgb(229, 229, 229);
  }
  @media ${(props) => props.theme.mediaQuery.desktop} {
    width: 300px;
  }
`;

// Determine the max-width for the PlpTileContainer
const getMaxWidth = (props) => {
  if (props.isPaginatedAlternatePlpEnabled) {
    return '312px';
  }
  if (props.isFourTileGridEnabled) {
    return '100%';
  }
  return '260px';
};

export const PlpTileContianer = styled.div`
  max-width: ${(props) => getMaxWidth(props)};
`;
export const VertcalPromoGrid = styled.div`
  display: inline-flex;
  flex-direction: column;
  ${(props) => {
    return props.isFullWidthTile
      ? `width: calc(${props.columnCount * 100}% + ${(props.columnCount - 1) * 20}px);`
      : '';
  }}

  &.fullwidth-mb {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: ${(props) => {
        const columnCount = props.columnCount || 1; // Default to 1 if undefined
        return `calc(200% + ${(columnCount - 1) * 20}px)`;
      }};
      min-width: ${(props) => {
        const columnCount = props.columnCount || 1; // Default to 1 if undefined
        return `calc(200% + ${(columnCount - 1) * 20}px)`;
      }};
    }
  }

  &.doubleTile,
  &.singleTileEspot {
    ${(props) =>
      props.isModuleContainer
        ? `
        max-height: 400px;
      padding-top: 22px;

    @media ${props.theme.mediaQuery.large} {
      max-height: 500px;
      padding-top: 30px;
    }
    `
        : ``}
  }

  &&.doubleTile {
    width: calc(200% + 20px);
    max-width: calc(200% + 20px);
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding-top: 0;
      padding-bottom: 30px;
    }
  }
`;

export const HorizontalBar = styled.hr`
  border-bottom-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
  border-bottom-width: 1px;
  margin: 0;
`;

export default css`
  .plp-grid,
  .slp-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 40px;
    @media ${(props) => props.theme.mediaQuery.small} {
      grid-template-columns: repeat(auto-fill, minmax(155px, 1fr));
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    }
    .item-title {
      grid-column: 1 / -1;
    }
    .item-title-no-show {
      grid-column: 1 / -1;
      display: none;
    }

    .empty-favorite-1 {
      fill: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
      stroke: ${(props) => props.theme.colors.NOTIFICATION.ERROR};
      stroke-linecap: round;
      stroke-linejoin: round;
    }
    .empty-favorite-2 {
      fill: none;
      stroke: ${(props) => props.theme.colors.BLACK};
      stroke-linecap: round;
      stroke-linejoin: round;
    }
    .hero-tile-container {
      grid-column: span 2;
    }
  }
  .plp-grid .hide-hero-tile {
    @media (min-width: 534px) and (max-width: 930px) {
      display: none;
    }
  }
  .plp-grid .skelton-hero-tile {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .image-height {
      @media ${(props) => props.theme.mediaQuery.large} {
        height: 850px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        height: 450px;
      }
    }
  }

  .four-grid {
    @media ${(props) => props.theme.mediaQuery.large} {
      grid-template-columns: repeat(4, minmax(180px, 1fr));
    }
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      grid-template-columns: repeat(4, minmax(220px, 1fr));
    }
  }

  .four-grid.plp-grid-redesign {
    .item-title {
      display: flex;
      align-items: center;
      gap: 12px;
      color: #595959;
      text-align: center;
      font-family: Nunito;
      font-size: 16px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 150%;
      letter-spacing: 1px;

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 20px !important;
      }
    }

    .horizontal-bar {
      flex-grow: 1;
      height: 1px;
      background-color: #ddd;
      border: none;
    }
  }

  .four-grid.plp-grid-redesign:not(:has(> :first-child.item-title)) {
    border-top: 1px solid #ddd;
    padding-top: 16px;
    grid-row-gap: 32px;
    @media ${(props) => props.theme.mediaQuery.large} {
      padding-top: 20px;
      grid-row-gap: 40px;
    }
  }

  .four-grid.plp-grid-redesign:has(> :first-child.item-title) {
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      grid-row-gap: 32px;
    }
  }

  .plp-grid.alternate-plp {
    margin: auto;
    grid-template-columns: repeat(auto-fill, minmax(312px, 1fr));

    .item-title {
      grid-column: 1 / -1;
    }
    .item-title-no-show {
      grid-column: 1 / -1;
      display: none;
    }
  }
  .shoByLookStylitics {
    padding-top: 0 !important;
    z-index: 0 !important;
  }
  .doubleTile.shoByLookStylitics {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: calc(200% + 20px) !important;
      max-width: calc(200% + 20px) !important;
    }
  }
  .fullWidthMbShoByLookStylitics {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      max-width: unset !important;
    }
  }
`;

export const StyledWrapper = styled.div`
  height: 29.5px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: none;
  }
`;

export const StyledSortSkelton = styled(LoaderSkelton)`
  height: 29.5px;
  width: 190px;
`;

export const smLoading = keyframes`
  to {
    background-position:
      500px 0,  // animation
      0 0,      // image
      0 222px,  // badge
      0 260px,  // title
      0 300px,  // swatches
      0 350px,  // add to bag
      0 0       // card
    ;
  }
`;

export const mdLoading = keyframes`
  to {
    background-position:
      500px 0,  // animation
      0 0,      // image
      0 289px,  // badge
      0 340px,  // title
      0 389px,  // swatches
      0 444px,  // add to bag
      0 0       // card
    ;
  }
`;

export const lgLoading = keyframes`
  to {
    background-position:
      500px 0,  // animation
      0 0,      // image
      0 363px,  // badge
      0 416px,  // title
      0 462px,  // swatches
      0 524px,  // add to bag
      0 0       // card
    ;
  }
`;

export const StyledPaginatedSkeleton = styled.div`
  height: 382px;
  padding: 12px;
  background-clip: content-box;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.6),
        rgba(255, 255, 255, 0)
      ),
      // animation
      linear-gradient(#d8d8d8 200px, transparent 0),
      // image
      linear-gradient(#d8d8d8 18px, transparent 0),
      // badge
      linear-gradient(#d8d8d8 16px, transparent 0),
      // title
      linear-gradient(#d8d8d8 15px, transparent 0),
      // swatches
      linear-gradient(#d8d8d8 32px, transparent 0),
      // add to bag
      linear-gradient(white, transparent 0) // card
;
    background-size: 100% 100%, 100% 200px, 40px 18px, 100% 16px, 100% 15px, 100% 32px, 100% 100%;
    background-position: -500px 0, 0 0, 0 222px, 0 260px, 0 300px, 0 350px, 0 0;
    background-repeat: no-repeat;
    animation: ${smLoading} 0.5s ease-in-out infinite;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    height: 486px;
    padding: 12px;

    &::after {
      background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0)
        ),
        linear-gradient(#d8d8d8 257px, transparent 0), linear-gradient(#d8d8d8 24px, transparent 0),
        linear-gradient(#d8d8d8 18px, transparent 0), linear-gradient(#d8d8d8 15px, transparent 0),
        linear-gradient(#d8d8d8 42px, transparent 0), linear-gradient(white, transparent 0);

      background-size: 100% 100%, 100% 257px, 50px 24px, 100% 18px, 100% 15px, 100% 42px, 100% 100%;

      background-position: -500px 0, 0 0, 0 289px, 0 340px, 0 389px, 0 444px, 0 0;
      animation: ${mdLoading} 0.5s ease-in-out infinite;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    height: 576px;
    padding: 12px;

    &::after {
      background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0)
        ),
        linear-gradient(#d8d8d8 344px, transparent 0), linear-gradient(#d8d8d8 27px, transparent 0),
        linear-gradient(#d8d8d8 19px, transparent 0), linear-gradient(#d8d8d8 20px, transparent 0),
        linear-gradient(#d8d8d8 52px, transparent 0), linear-gradient(white, transparent 0);

      background-size: 100% 100%, 100% 344px, 53px 27px, 100% 19px, 100% 20px, 100% 52px, 100% 100%;

      background-position: -500px 0, 0 0, 0 363px, 0 416px, 0 462px, 0 524px, 0 0;
      animation: ${lgLoading} 0.5s ease-in-out infinite;
    }
  }
`;

export const L2TitleSkeleton = styled(LoaderSkelton)`
  height: 32px;
  width: 150px;
`;

export const L2TitleWrapper = styled.div`
  width: 100%;
  grid-column: 1 / -1;
`;

export const RenderText = styled(RichText)`
  text-align: center;
  font-size: ${(props) => props.theme.typography.fontSizes.fs16};
  @media ${(props) => props.theme.mediaQuery.large} {
    font-size: ${(props) => props.theme.typography.fontSizes.fs26};
    display: ${(props) => (props.tablet ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
`;

export const TopPromoWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.desktop} {
    ${(props) => (props?.isHplp ? 'width:99%;' : '')}
    ${(props) => (props.isHplp && props.isPillVariation ? `margin-left: 18px;` : ``)}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    display: ${(props) => (props.tablet ? 'none' : 'block')};
    ${(props) => (props.isHplp && props.isPillVariation ? `margin-left: 16px;` : ``)}
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
  ${plpPromoModuleMobile}
`;

export const TopPromoWrapperV3 = styled.div`
  @media ${(props) => props.theme.mediaQuery.large} {
    display: ${(props) => (props.tablet ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
  ${plpPromoModuleMobile}
`;

export const StyledReadMore = styled(ReadMore)`
  max-width: 90%;
  margin: 0 auto;
  @media ${(props) => props.theme.mediaQuery.xlarge} {
    max-width: 70%;
  }
`;

export const ItemsCountWrapper = styled.div`
  width: max-content;
  text-align: right;
  position: relative;
  font-family: ${(props) => props.theme.typography.fonts.secondary};
  ${(props) => (props.isOneHrFilterEnabled ? 'margin-bottom: 24px' : '')};
  ${(props) => (props.isOneHrFilterEnabled ? 'z-index: 10' : '')};
  margin-left: auto;
  @media ${(props) => props.theme.mediaQuery.large} {
    display: none;
  }
`;

export const ItemsCount = styled.span`
  font-weight: 900;
  padding: 4px;
  font-size: 16px;
`;

export const ItemsText = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const CategoryPromotionWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.large} {
    display: ${(props) => (props.tablet ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
`;

export const TrendingInCategoryCarouselWrapper = styled.div`
  @media ${(props) => props.theme.mediaQuery.large} {
    display: ${(props) => (props.tablet ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    display: ${(props) => (props.desktop ? 'none' : 'block')};
  }
`;

export const StyledESpotPromoSkeleton = styled.div`
  height: calc(100% - 22px);
  padding-top: 22px;
  background-clip: content-box;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.6),
        rgba(255, 255, 255, 0)
      ),
      linear-gradient(#d8d8d8 100%, transparent 0), linear-gradient(white, transparent 0);
    background-size: 100%;
    animation: ${smLoading} 0.5s ease-in-out infinite;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    &::after {
      animation: ${mdLoading} 0.5s ease-in-out infinite;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    height: calc(100% - 29px);
    padding-top: 29px;
    &::after {
      animation: ${lgLoading} 0.5s ease-in-out infinite;
    }
  }
`;

export const SortAndFilterWrapper = styled.div`
  ${({ isMountedHideLeftNavigationOnPLPEnabled }) =>
    isMountedHideLeftNavigationOnPLPEnabled &&
    `display: flex;
  column-gap: 28px;
  margin-bottom: 28px;`}

  @media ${(props) => props.theme.mediaQuery.large} {
    ${({ isAppliedFilterPill }) => (isAppliedFilterPill ? 'margin-bottom: 16px;' : '')};
  }

  ${({ isQuickFiltersEnabled }) =>
    isQuickFiltersEnabled
      ? css`
          display: flex;
          justify-content: space-between;
        `
      : ''}

  ${({ isPLPSortAndOneHrFilterRedesignEnabled }) =>
    isPLPSortAndOneHrFilterRedesignEnabled
      ? css`
          @media ${(props) => props.theme.mediaQuery.large} {
            &.sort-and-filter-redesign.sort-and-filter-redesign.sort-and-filter-redesign {
              display: flex;
              justify-content: initial;
              align-items: center;
              width: 100%;
              overflow: hidden;
              column-gap: unset;
              margin-bottom: 16px;

              .one-hr-filter-and-sort-selector-wrapper {
                max-height: unset;
                margin: 0;
              }

              .sort-by-component-wrapper {
                width: auto;
              }

              .sort-dropdown-wrapper {
                padding: 12px;
                flex-shrink: 0;
              }

              .sort-select-title,
              .sort-item-selected,
              .sort-filter-label {
                white-space: nowrap;
                padding: 0;
                color: #000;
                font-family: Nunito;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: 150%;
                letter-spacing: 0.5px;
                text-transform: capitalize;
              }

              .sort-select-title {
                padding-right: 5px;
              }

              .sort-item-selected {
                width: unset;
              }

              .custom-sort-dropdown {
                padding: 0;
                border: none;
              }

              .sort-filter-label {
                padding-right: 16px;
              }

              .sort-filter-label:before,
              .sort-filter-label:after {
                background: #000;
                height: 1px;
              }

              #one-hr-filter {
                margin-left: auto;
                flex-grow: 1;
              }
            }
          }
        `
      : ''}

  .show-hide-filters-button {
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    padding: 12px;
    column-gap: 8px;
    border: none;
    background: white;
    color: #000;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    width: auto;
    flex: 0 0 auto;

    &:hover {
      background: #f3f3f3;
    }

    .filter-icon {
      width: 24px;
      height: 24px;
    }
  }
`;

export const SortByComponentWrapper = styled.div`
  ${({ isMountedHideLeftNavigationOnPLPEnabled }) =>
    isMountedHideLeftNavigationOnPLPEnabled &&
    css`
      display: flex;
      width: 100%;

      .one-hr-filter-and-sort-selector-wrapper {
        width: 100%;
        justify-content: space-between;

        #one-hr-filter {
          flex: 0 0 auto;
        }
      }

      .one-hr-filter-and-sort-selector-wrapper {
        margin-bottom: 0;
        max-height: unset;
        align-items: center;
        justify-content: end;
        gap: 12px;
        .sort-dropdown-wrapper {
        }

        .sort-select-title {
          color: #000;
          font-family: Nunito;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          padding-right: 9px;
        }

        .custom-sort-dropdown {
          color: #000;
          font-family: Nunito;
          font-size: 13px;
          font-style: normal;
          font-weight: 800;
          line-height: normal;
          height: max-content;
        }

        .one-hr-filter-text-area {
          display: flex;
          align-items: center;
          column-gap: 10px;
        }

        .one-hr-filter-text-area-label {
          color: #000;
        }

        .change-store-link {
          margin: 0;
        }

        .change-store-link p {
          color: #165c9e;
          font-weight: 600;
          line-height: 159%;
        }
      }
    `}

  ${({ isPLPSortAndOneHrFilterRedesignEnabled }) =>
    isPLPSortAndOneHrFilterRedesignEnabled
      ? css`
          &.one-hr-filter-container {
            margin-left: auto;

            .one-hr-filter-redesign {
              margin: 0;
            }
          }
        `
      : ''}
`;
export const QuickFiltersWrapper = styled.div`
  display: none;

  @media ${(props) => props.theme.mediaQuery.large} {
    display: block;
    width: -webkit-fill-available;
  }
`;
